import { Component, OnInit, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material';

import { QueueService } from './queue.service';
import { parseErrors } from '../shared/api.service';

@Component({
  selector: 'skip-queue-dialog',
  templateUrl: './skip-queue-dialog.component.html',
  styleUrls: ['./skip-queue-dialog.component.scss'],
  providers: []
})
export class SkipQueueDialogComponent implements OnInit {
  loading = false;
  model: any = { reason: '' };
  errors = [];
  callback;
  skipQueueReq;

  constructor(
    public dialogRef: MatDialogRef<SkipQueueDialogComponent>,
    private elementRef: ElementRef,
    private queueService: QueueService
  ) { }

  ngOnInit() { }

  submit() {
    this.loading = true;
    if (this.skipQueueReq) { this.skipQueueReq.unsubscribe(); }
    this.skipQueueReq = this.queueService.skip(this.model).subscribe(queue => {
      this.loading = false;
      this.callback();
      this.dialogRef.close();
    }, err => {
      this.loading = false;
      this.errors = parseErrors(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/patient-queue/skip-queue-dialog.component.ts